import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Brand } from './Brand';

export const Header: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="auth-header">
      <div className="auth-header-in">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div className="auth-brand" style={{ margin: 0 }}>
            <Brand variant="lockup" height={28} />
          </div>
        </Link>
        <nav style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
          {user ? (
            <>
              <Link to="/dashboard">Dashboard</Link>
              <span style={{ color: 'var(--faint)', fontSize: 13 }}>{user.email}</span>
              <button
                onClick={logout}
                className="auth-btn auth-btn-ghost"
                style={{ height: 38, width: 'auto', padding: '0 16px' }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
              <Link
                to="/register"
                className="auth-btn"
                style={{ height: 38, width: 'auto', padding: '0 16px', color: '#241d0b' }}
              >
                Sign Up
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};





